export enum RoleType {
    Admin = 'Administrator',
    Employee = 'Zaposleni',
    Agency = 'Agencija',
    Test = 'Test',
    Supervizor = 'Supervizor',
    Host = "Host"
}

export interface Role {
    id: string;
    name: RoleType;
}
